"use client"

import * as React from "react"
import { cn } from '../../../../lib/utils'
import { gridSkeletonVariants } from "../constants"
import { useGridViewOptional } from "../use-grid-view"
import type { GridSkeletonProps } from "../types"

const GridSkeleton = React.forwardRef<HTMLDivElement, GridSkeletonProps>(
  ({ className, count, aspectRatio = "square", ...props }, ref) => {
    const gridContext = useGridViewOptional()
    const itemCount = count ?? (gridContext?.columnCount ?? 4) * 3

    return (
      <>
        {Array.from({ length: itemCount }).map((_, i) => (
          <div
            key={`skeleton-${i}`}
            ref={i === 0 ? ref : undefined}
            className={cn(gridSkeletonVariants({ aspectRatio }), className)}
            {...props}
          />
        ))}
      </>
    )
  }
)

GridSkeleton.displayName = "GridSkeleton"

export { GridSkeleton }
